@import "../variables";

.container {
  padding: 24px 16px;

  @media (min-width: $size-md) {
    padding-bottom: 80px;
    margin: 0 auto;
    width: 604px;
  }

  @media (min-width: $size-lg) {
    padding-bottom: 120px;
    width: 676px;
  }

  &__header {
    h2 {
      font-size: 28px;
      letter-spacing: 0.6px;
      margin-bottom: 16px;
    }
  }

  &__form {
    @media (min-width: $size-md) {
      width: 320px;
    }

    &_container {
      padding: 16px;
      color: $color-grey;
      background-color: white;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
      border-radius: 4px;
    }

    label {
      line-height: 19px;
    }

    select,
    input {
      font-weight: bold;
    }

    &_group {
      margin-bottom: 10px;
    }
  }

  &__buttons {
    display: flex;
    flex-direction: column-reverse;
    margin-top: 9px;

    @media (min-width: $size-md) {
      margin-top: 37px;
      flex-direction: row;
      justify-content: flex-end;
    }

    button {
      width: 100%;
      font-weight: bold;
      margin-top: 20px;

      @media (min-width: $size-md) {
        width: 120px;
        margin-left: 20px;
        margin-top: 0;
      }

      &:first-of-type {
        @media (min-width: $size-md) {
          width: 80px;
        }
      }
    }
  }
}